import { render } from "./indexList.vue?vue&type=template&id=fc8453ec"
import script from "./indexList.vue?vue&type=script&lang=js"
export * from "./indexList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__